import { useCallback } from "react"

/**
 * Custom hook for handling Health filters
 * Manages period filter changes with support for custom periods
 */
export const useHealthFilters = (changeFiltersAction) => {
  const handleChangeFilter = useCallback(
    (newFilters) => {
      if (Array.isArray(newFilters.period)) {
        changeFiltersAction({ period: { type: "custom", period: newFilters.period } })
      } else {
        changeFiltersAction(newFilters)
      }
    },
    [changeFiltersAction]
  )

  return { handleChangeFilter }
}
